export const GAMES_DATA = {
  game1: {
    title: "Dog to Cat",
    startWord: "DOG",
    endWord: "CAT",
    columns: [
      [
        { letter: "B", text: "SNOOPY" },
        { letter: "D", text: "PLUTO" },
        { letter: "C", text: "MICKEY" },
      ],
      [
        { letter: "E", text: "PEANUTS" },
        { letter: "F", text: "DISNEY" },
        { letter: "G", text: "PLANET" },
      ],
      [
        { letter: "H", text: "LINUS" },
        { letter: "I", text: "CHESHIRE" },
        { letter: "J", text: "STEVENS" },
      ],
    ],
    links: ["<B", "<D", "BE", "DF", "DG", "EH", "FI", "FJ", "GJ", "I>", "J>"],
    timeLimit: 60,
    penaltyAmount: 20
  },
  game2: {
    title: "Elon Musk to Al Franken",
    startWord: "ELON MUSK",
    endWord: "AL FRANKEN",
    columns: [
      [
        { letter: "A", text: "SPACE" },
        { letter: "B", text: "CARS" },
        { letter: "C", text: "CANDY" },
      ],
      [
        { letter: "D", text: "MARS" },
        { letter: "E", text: "JOHN GLEN" },
        { letter: "F", text: "HENRY FORD" },
      ],
      [
        { letter: "G", text: "SNL" },
        { letter: "H", text: "DETROIT" },
        { letter: "I", text: "SENATE" },
      ],
    ],
    links: ["<A", "<B", "AD", "AE", "BF", "DH", "EI", "FH", "I>"],
    timeLimit: 60,
  },
  game3: {
    title: "Jesus to Cheeses",
    startWord: "JESUS",
    endWord: "CHEESES",
    columns: [
      [
        { letter: "A", text: "CARPENTER" },
        { letter: "B", text: "BECKHAM" },
        { letter: "C", text: "CROSS" },
      ],
      [
        { letter: "D", text: "DAVID" },
        { letter: "E", text: "JOHN" },
        { letter: "F", text: "BOW" },
      ],
      [
        { letter: "G", text: "TIE" },
        { letter: "H", text: "TEE" },
        { letter: "I", text: "VIOLA" },
      ],
      [
        { letter: "J", text: "GOLF" },
        { letter: "K", text: "RAILROAD" },
        { letter: "L", text: "FIGHTER" },
      ],
      [
        { letter: "M", text: "BATTERY" },
        { letter: "N", text: "ARMY" },
        { letter: "O", text: "NICKLAUS" },
      ],
      [
        { letter: "Q", text: "SWISS" },
        { letter: "R", text: "JACK" },
        { letter: "S", text: "TESLA" },
      ],
    ],
    links: [
      "<A",
      "<C",
      "CD",
      "CF",
      "AE",
      "FG",
      "FI",
      "IL",
      "GL",
      "LN",
      "NQ",
      "Q>",
    ],
    timeLimit: 90,
  },
  game4: {
    title: "George Washington to Tom Cruise",
    startWord: "GEORGE WASHINGTON",
    endWord: "TOM CRUISE",
    columns: [
      [
        { letter: "B", text: "LIVED IN DC" },
        { letter: "C", text: "SERVED 2 TERMS" },
        { letter: "D", text: "WOODEN TEETH" },
      ],
      [
        { letter: "E", text: "RONALD REAGAN" },
        { letter: "F", text: "BARACK OBAMA" },
        { letter: "G", text: "ABRAHAM LINCOLN" },
      ],
      [
        { letter: "H", text: "DIVORCED AT AGE 33" },
        { letter: "I", text: "BORN IN NY" },
        { letter: "J", text: "MOVIE STAR" },
      ],
    ],
    links: [
      "<B",
      "<C",
      "<D",
      "BE",
      "BF",
      "BG",
      "CE",
      "CF",
      "EJ",
      "EH",
      "J>",
    ],
    timeLimit: 30,
  },
  game5: {
    title: "California to Louisiana",
    startWord: "CALIFORNIA",
    endWord: "LOUISIANA",
    columns: [
      [
        { letter: "B", text: "CUBAN SANDWICH" },
        { letter: "C", text: "CORN DOG" },
        { letter: "D", text: "FORTUNE COOKIE" },
      ],
      [
        { letter: "E", text: "DUMB AND DUMBER" },
        { letter: "F", text: "SCARFACE" },
        { letter: "G", text: "JOY LUCK CLUB" },
      ],
      [
        { letter: "H", text: "1986" },
        { letter: "I", text: "1993" },
        { letter: "J", text: "2010" },
      ],
      [
        { letter: "K", text: "GIBSON GUITAR" },
        { letter: "L", text: "TACO BELL" },
        { letter: "M", text: "BEANIE BABIES" },
      ],
      [
        { letter: "N", text: "TOBASCO" },
        { letter: "O", text: "BLUES MUSIC" },
        { letter: "P", text: "JARED LETO" },
      ],
    ],
    links: ["<D", "DG", "GI", "IM", "MN", "N>"],
    timeLimit: 75,
  },
  game6: {
    title: "Best Picture to 1997",
    startWord: "BEST PICTURE",
    endWord: "1997",
    columns: [
      [
        { letter: "B", text: "THE ENGLISH PATIENT" },
        { letter: "C", text: "FARGO" },
        { letter: "D", text: "SHINE" },
        { letter: "E", text: "SLING BLADE" },
        { letter: "F", text: "JERRY MAGUIRE" },
        { letter: "G", text: "SECRETS & LIES" }
      ],
    ],
    links: ["<B", "B>"],
    timeLimit: 30,
  },
  game9: {
    title: "RBI to ALL-TIME LEADER",
    startWord: "RBI",
    endWord: "ALL-TIME LEADER",
    columns: [
      [
        { letter: "B", text: "ALEX RODRIQUEZ" },
        { letter: "C", text: "HANK AARON" },
        { letter: "D", text: "BABE RUTH" },
      ],
    ],
    links: ["<C", "C>"],
    timeLimit: 30,
  },
  game10: {
    title: "Nikola to Michael",
    startWord: "NIKOLA",
    endWord: "MICHAEL",
    columns: [
      [
        { letter: "B", text: "TESLA" },
        { letter: "C", text: "COSTER-WALDAU" },
        { letter: "D", text: "CAGE" },
      ],
      [
        { letter: "E", text: "RAISING ARIZONA" },
        { letter: "F", text: "AC" },
        { letter: "G", text: "GAME OF THRONES" },
      ],
      [
        { letter: "H", text: "MARVEL" },
        { letter: "I", text: "HBO" },
        { letter: "J", text: "DC" },
      ],
      [
        { letter: "K", text: "BATMAN" },
      ],
      [
        { letter: "L", text: "KEATON" },
        { letter: "M", text: "CLOONEY" },
        { letter: "N", text: "BALE" },
      ],
      [
        { letter: "O", text: "DIANE" },
        { letter: "P", text: "HAY" },
        { letter: "Q", text: "GEORGE" },
      ],
    ],
    links: [
      "<B", "<C", "<D", "BE", "BF", "CG", "DG", "EH", "FI", "GI", "HJ", "HK",
      "JK", "KL", "KM", "KN", "LO", "MP", "NP", "OQ", "PQ", "Q>"
    ],
    timeLimit: 60,
  },
  game11: {
    title: "Saint to Florida",
    startWord: "SAINT",
    endWord: "FLORIDA",
    columns: [
      [
        { letter: "B", text: "FRANCIS" },
        { letter: "C", text: "LOUIS" },
        { letter: "D", text: "PETERSBURG" },
      ],
    ],
    links: ["<B", "<C", "<D", "D>"],
    timeLimit: 30,
  },
  game12: {
    title: "California to Louisiana",
    startWord: "CALIFORNIA",
    endWord: "LOUISIANA",
    columns: [
      [
        { letter: "B", text: "CUBAN SANDWICH" },
        { letter: "C", text: "CORN DOG" },
        { letter: "D", text: "FORTUNE COOKIE" },
      ],
      [
        { letter: "E", text: "DUMB AND DUMBER" },
        { letter: "F", text: "SCARFACE" },
        { letter: "G", text: "JOY LUCK CLUB" },
      ],
      [
        { letter: "H", text: "1986" },
        { letter: "I", text: "1993" },
        { letter: "J", text: "2010" },
      ],
      [
        { letter: "K", text: "GIBSON GUITAR" },
        { letter: "L", text: "TACO BELL" },
        { letter: "M", text: "BEANIE BABIES" },
      ],
      [
        { letter: "N", text: "TABASCO" },
        { letter: "O", text: "BLUES MUSIC" },
        { letter: "P", text: "JARED LETO" },
      ],
    ],
    links: ["<D", "DF", "FH", "HM", "MN", "N>"],
    timeLimit: 60,
  },
  game13: {
    title: "Detroit to Baseball",
    startWord: "DETROIT",
    endWord: "BASEBALL",
    columns: [
      [
        { letter: "B", text: "LIONS" },
        { letter: "C", text: "TIGERS" },
        { letter: "D", text: "BLUE JAYS" },
        { letter: "E", text: "BEARS" },
        { letter: "F", text: "CARDINALS" },
        { letter: "G", text: "BRONCOES" },
        { letter: "H", text: "DOLPHINS" },
        { letter: "I", text: "BRUINS" },
        { letter: "J", text: "SHARKS" }
      ],
    ],
    links: ["<C", "C>"],
    timeLimit: 60,
  },
};